import { render, staticRenderFns } from "./CloneSchedule.vue?vue&type=template&id=876c4b7c&"
import script from "./CloneSchedule.vue?vue&type=script&lang=ts&"
export * from "./CloneSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports